import { createElementBlock as o, openBlock as r, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return r(), o("svg", n, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11 11H6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2M6 9a4 4 0 0 0-4 4v5a4 4 0 0 0 4 4h5a4 4 0 0 0 4-4v-5a4 4 0 0 0-4-4z",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.551 4.77A2.57 2.57 0 0 0 11 6.347a1 1 0 1 1-2 0c0-.918.3-1.987 1.003-2.845.728-.89 1.85-1.503 3.345-1.503H17.7c1.038 0 2.111.345 2.937 1.087C21.481 3.845 22 4.96 22 6.347V10.7c0 1.222-.417 2.253-1.19 3.005-.758.736-1.776 1.127-2.857 1.25a1 1 0 0 1-.227-1.987c.765-.087 1.328-.346 1.69-.697.344-.335.584-.83.584-1.571V6.348c0-.86-.306-1.42-.7-1.773-.411-.37-.988-.575-1.6-.575h-4.352c-.896 0-1.449.344-1.797.77",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_copy-HHLap5eJ.js.map
